import React, { useEffect } from 'react';
import Layout from '@sls-react/components/Layout';
import { NextPage } from 'next';
import { RailsPageView } from '@sls-react/typings/services/rails/tile';
import { visitedHomepage } from '@sls-react/services/analytics/events/generic';
import { fetchAllPageViewData, fetchPageView } from '@sls-react/api/tiles';
import selectEnv from '@sls-react/utils/selectEnv';
import PageView from '@sls-react/components/legos/PageView';
import { PageViewDataContext } from '@sls-react/contexts/PageViewDataContext';
import { useMount } from 'react-use';
import getQueryClient from '@sls-react/utils/getQueryClient';
import { dehydrate } from 'react-query/hydration';

interface Props {
  pageView?: RailsPageView;
  pageViewData?: any;
}

const Homepage: NextPage<Props> = ({ pageView, pageViewData }) => {
  useMount(visitedHomepage);

  return (
    <Layout
      titleTemplate=""
      title="SidelineSwap | Buy and sell sports equipment: Hockey, Lacrosse, Baseball, Ski and more."
      container={false}
    >
      <PageViewDataContext.Provider value={{ data: pageViewData, pageView }}>
        <PageView pageView={pageView} />
      </PageViewDataContext.Provider>
    </Layout>
  );
};

Homepage.getInitialProps = async ctx => {
  const queryClient = getQueryClient();
  const pageView = await fetchPageView.call(ctx, selectEnv(48, 9));
  const pageViewData = await fetchAllPageViewData(
    pageView,
    ctx.device === 'mobile',
    {},
    queryClient,
  );

  return {
    pageView,
    pageViewData,
    dehydratedState: dehydrate(queryClient),
  };
};

// noinspection JSUnusedGlobalSymbols
export default Homepage;
